import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paperclip } from 'lucide-react';
import { memo } from 'react';
import { AttachmentCard } from '../AttachmentCard';
/**
 * Renders attachments message part with file preview cards
 */ export const AttachmentsPart = /*#__PURE__*/ memo(function AttachmentsPart({ part, messageId, index }) {
    const data = part.data;
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full space-y-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "text-xs font-semibold flex items-center gap-2 text-muted-foreground",
                children: [
                    /*#__PURE__*/ _jsx(Paperclip, {
                        className: "w-3.5 h-3.5"
                    }),
                    data.length === 1 ? '1 Attachment' : `${data.length} Attachments`
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-col gap-2",
                children: data.map((attachment, i)=>/*#__PURE__*/ _jsx(AttachmentCard, {
                        attachment: attachment
                    }, `${attachment.id ?? attachment.name}-${i}`))
            })
        ]
    }, `${messageId}-attachments-${index}`);
});
